import React, { useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
} from "reactstrap";
import { DatePicker } from "reactstrap-date-picker";
import { MdOutlineDateRange } from "react-icons/md";
import AccessList from "../AccessList";
import ChoseMembers from "../ChoseMembers";
import SelectedUser from "../SelectedUser";
import { DataContext } from "../../context/DataContext";
import InputField from "../InputField";

function ShareModal(props) {
  const { formik } = props;
  // console.log(formik.errors, formik.values);
  const {
    passwordAccess,
    folderAccess,
    envAccess,
    deletePermission,
    updatePermission,
    createPermission,
  } = useContext(DataContext);
  return (
    <Modal
      isOpen={props.shareModal}
      toggle={props.shareModaltoggle}
      size={props?.md ? "md" : "lg"}
      centered
    >
      <ModalHeader toggle={props.shareModaltoggle}>
        {props?.isFolder || props?.isEnv
          ? "Share Folder/Subfolder"
          : "Share Password"}
      </ModalHeader>
      <ModalBody>
        <Form className="formWrap">
          <div className="row">
            <div className={props?.md ? "" : "col-6"}>
              <ChoseMembers
                onSelect={(user) => {
                  props?.handleSelectUsers(user);
                }}
              />
            </div>
            {props?.isFolder || props?.isEnv ? null : (
              <div className="col-6">
                <div className="formSelectWrap">
                  <Label>Permission Type</Label>
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "permissionType",
                        e.target.value
                      );
                    }}
                  >
                    <option>View</option>
                    <option>Edit</option>
                  </Input>
                </div>
              </div>
            )}

            <SelectedUser
              onRemove={(user) => props?.removeSelectUsers(user)}
              selectedUsers={props?.selectedUsers}
            />
            {props?.isFolder || props?.isEnv ? null : (
              <div className="col-6">
                <div className="formElmWrap mb-3 dateWrap">
                  <div className="formSelectWrap ">
                    <Label>Expiry Date</Label>
                    <DatePicker
                      showClearButton={true}
                      placeholder="Expiry Date"
                      minDate={new Date().toDateString() + 86400000}
                      value={formik.values.expiryDate}
                      onChange={(e) =>
                        formik.setFieldValue(
                          "expiryDate",
                          e?.split("T")[0]
                        )
                      }
                    />
                    <span className="formIcon dateIcon">
                      {<MdOutlineDateRange />}
                    </span>
                    {formik.touched.expiryDate &&
                    formik.errors.expiryDate ? (
                      <Label style={{ color: "red" }}>
                        {formik.errors.expiryDate}
                      </Label>
                    ) : null}
                  </div>
                </div>
              </div>
            )}

            <div className={props?.md ? "" : "col-6"}>
              <div className="formSelectWrap">
                <InputField
                  formik={formik}
                  id="note"
                  name="note"
                  type="textarea"
                  placeholder="Note"
                  value={formik.values.note}
                  touch={formik.touched.note}
                  error={formik.errors.note}
                  rows={7}
                />
              </div>
            </div>
          </div>

          {props?.isPassword ? (
            <AccessList
              pwAccess={passwordAccess?.passwordAccess || []}
              envAccess={passwordAccess?.envAccess || []}
              folderAccess={passwordAccess?.folderAccess || []}
              details={true}
              deleteOption={"password"}
              onDelete={async (shareId, permissionId) => {
                await deletePermission(shareId, permissionId);
                props?.refetchAccessList();
              }}
              onUpdate={async (data, perId = null) => {
                await updatePermission(
                  {
                    permissionType: data?.permissionType,
                    expiryDate: data?.expiryDate,
                  },
                  perId
                );
                props?.refetchAccessList();
              }}
              onCreate={async (data, perId = null) => {
                await createPermission({
                  permissionType: data?.permissionType,
                  expiryDate: data?.expiryDate,
                  passwordId: formik.values?.passwordId,
                  shareWith: data?.shareWith,
                });
                props?.refetchAccessList();
              }}
            />
          ) : null}
          {props?.isEnv ? (
            <AccessList
              pwAccess={[]}
              envAccess={envAccess?.envAccess}
              folderAccess={envAccess?.folderAccess}
              details={false}
              deleteOption={"env"}
              onDelete={(shareId, permissionId) => {
                deletePermission(shareId, permissionId);
                props?.refetchAccessList();
              }}
            />
          ) : null}
          {props?.isFolder ? (
            <AccessList
              pwAccess={[]}
              envAccess={[]}
              folderAccess={folderAccess}
              details={false}
              deleteOption={"folder"}
              onDelete={(shareId, permissionId) => {
                deletePermission(shareId, permissionId);
                props?.refetchAccessList();
              }}
            />
          ) : null}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color={
            props?.selectedUsers.length > 0 ? "primary" : "disable"
          }
          onClick={() => {
            if (props?.selectedUsers.length > 0)
              formik.handleSubmit();
          }}
        >
          Share
        </Button>
        <Button color="outline" onClick={props.shareModaltoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ShareModal;
